import * as variantManagement from './variantManagement.service';
import * as couponManagement from './couponManagement.service';

export const ShoppingCartServices = {
  ...variantManagement,
  ...couponManagement,
};
